module.exports = __webpack_public_path__ + "img/users.00172ce8.svg";